import Controller from '@ember/controller';

export default class AuthenticatedPlaylistsShowTeamsIndexController extends Controller {}
